import { useNavigation } from '../../../Common/services/utils/polyfills';
import {
  MainNavigationProp,
  StackParamList,
} from '../../navigation/main/MainStackNavigator';

export const useAppNavigation = (): MainNavigationProp<keyof StackParamList> =>
  useNavigation<MainNavigationProp<keyof StackParamList>>();
